(function(app, ng) {

    app.config(["$stateProvider", function($stateProvider) {
        $stateProvider.state("Transaction",
            {
                url: "/Transaction",
                component: "transaction",
                redirectTo: "Transaction.Initiate",
                requiredPermissions: [{ AccessObject: "Transaction", ActionType: "Create" }],
                resolve: {
                    transaction: [
                        "transactionApi", "$stateParams", function(transactionApi, $stateParams) {
                            if ($stateParams.transactionId)
                                return transactionApi.get($stateParams.transactionId);
                        }
                    ],
                    transactionGroup: [
                        "userApi", function(userApi) {
                            return userApi.getUserTransactionGroup();
                        }
                    ],
                    logo: [
                        "transactionGroup", "transactionGroupApi", function(transactionGroup, transactionGroupApi) {
                            return transactionGroupApi.getLogo(transactionGroup.Id)
                                .then(function(response) {
                                    return URL.createObjectURL(response);
                                }, function() { return "Images/icomply-logo-light-bg-tm@2x.png" });
                        }
                    ],
                    user: [
                        "userApi", function(userApi) {
                            return userApi.getCurrentUser();
                        }
                    ],
                    disclosures: ["transactionGroupApi", "transactionGroup", "transactionApi", "transaction", "_",
                        function(transactionGroupApi, transactionGroup, transactionApi, transaction, _) {
                            return transaction
                                ? transactionApi.getDisclosures(transaction.Id)
                                : transactionGroupApi.getDisclosures(transactionGroup.Id);
                        }
                    ],
                    onBefore: ["$state", "transaction", "transactionStatus", "_", "permissionService",
                        function($state, transaction, transactionStatus, _, permissionService) {
                            if (!permissionService.hasAllPermissions([{ AccessObject: "Transaction", ActionType: "Create" }]))
                                $state.go("Home.Dashboard");
                            if (transaction) {
                                var status = _.findIndex(transactionStatus.locked, function(item) {
                                    return item.Value === transaction.TransactionStatus;
                                });

                                if (status !== -1) {
                                    $state.go("Home.ViewTransactions");
                                }
                            }
                        }]
                }
            });
    }]);

    app.component("transaction",
        {
            templateUrl: "/App/Transaction/template.html",
            controller: transactionController,
            bindings: {
                transaction: "<",
                transactionGroup: "<",
                logo: "<",
                user: "<",
                disclosures: "<"
            }
        });

    transactionController.$inject = ["$state", "$mdDialog", "_"];
    function transactionController($state, $mdDialog, _) {
        var $ctrl = this;
        
        ng.extend($ctrl,
            {
                getCurrentStage: getCurrentStage,
                goToDashboard: goToDashboard,
                leaveTransaction: leaveTransaction
            });

        function getCurrentStage(state) {          
            $ctrl.currentStage = _.findIndex($ctrl.transactionStages,
                function(stage) {
                    if (state.$current.includes["Transaction.Initiate"])
                        return stage.Title === "Initiate";
                    else if (state.$current.includes["Transaction.Disclose"])
                        return stage.Title === "Disclose";
                    else if (state.$current.includes["Transaction.Capture"])
                        return stage.Title === "Capture";
                    else if (state.$current.includes["Transaction.Determine"])
                        return stage.Title === "Determine";
                    else if (state.$current.includes["Transaction.Application"])
                        return stage.Title === "Application";
                    else if (state.$current.includes["Transaction.RightBridgeReturn"])
                        return stage.Title === "Determine";
                    else if (state.$current.includes["Transaction.RetireUpReturn"])
                        return stage.Title === "Determine";
                });

            if (_.some($ctrl.transactionStages,
                function(stage) {
                    return stage.Title === "Capture";
                }))
                $ctrl.currentCaptureStage = _.findIndex($ctrl.captureStages,
                    function(stage) {
                        if (state.$current.includes["Transaction.Capture.Finances"])
                            return stage.CapturePoint === "Finances";
                        else if (state.$current.includes["Transaction.Capture.Funding"])
                            return stage.CapturePoint === "Funding";
                        else if (state.$current.includes["Transaction.Capture.Households"])
                            return stage.CapturePoint === "Households";
                        else if (state.$current.includes["Transaction.Capture.NeededDocuments"])
                            return stage.CapturePoint === "NeededDocuments";
                        else if (state.$current.includes["Transaction.Capture.Questionnaire"])
                            return stage.CapturePoint === "Questionnaire";
                    });
        }

        function goToDashboard() {
            $state.go("Home.Dashboard");
        }

        function leaveTransaction($event) {
            var leave = $mdDialog.confirm({
                title: "Are you sure you would like to exit this transaction?",
                targetEvent: $event,
                ariaLabel: "Confirm discarding transaction",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave)
                .then(function() {
                    goToDashboard();
                });
        }

        this.$onInit = function() {
            $ctrl.transactionStages = [
                { Title: "Initiate", State: null },
                { Title: "Disclose", State: $ctrl.transaction ? $state.href("Transaction.Disclose", { transactionId: $ctrl.transaction.Id }) : null },
                { Title: "Capture", State: $ctrl.transaction ? $state.href("Transaction.Capture", { transactionId: $ctrl.transaction.Id }) : null },
                { Title: "Determine", State: $ctrl.transaction ? $state.href("Transaction.Determine", { transactionId: $ctrl.transaction.Id }) : null },
                { Title: "Application", State: null }
            ];

            $ctrl.captureStages = [
                { Title: "Finances", CapturePoint: "Finances", State: $ctrl.transaction ? $state.href("Transaction.Capture.Finances", { transactionId: $ctrl.transaction.Id }) : null },
                { Title: "Funding", CapturePoint: "Funding", State: $ctrl.transaction ? $state.href("Transaction.Capture.Funding", { transactionId: $ctrl.transaction.Id }) : null },
                { Title: "Household", CapturePoint: "Households", State: $ctrl.transaction ? $state.href("Transaction.Capture.Households", { transactionId: $ctrl.transaction.Id }) : null },
                { Title: "Documents", CapturePoint: "NeededDocuments", State: $ctrl.transaction ? $state.href("Transaction.Capture.NeededDocuments", { transactionId: $ctrl.transaction.Id }) : null },
                { Title: "Questionnaire", CapturePoint: "Questionnaire", State: $ctrl.transaction ? $state.href("Transaction.Capture.Questionnaire", { transactionId: $ctrl.transaction.Id }) : null }
            ];

            if ($ctrl.disclosures.length === 0)
                _.remove($ctrl.transactionStages,
                    function(stage) {
                        return stage.Title === "Disclose";
                    });

            var capturePoints = $ctrl.transaction
                ? $ctrl.transaction.CapturePoints
                : $ctrl.transactionGroup.CapturePoints;

            if (capturePoints.length === 0)
                _.remove($ctrl.transactionStages,
                    function(stage) {
                        return stage.Title === "Capture";
                    });
            else {
                _.remove($ctrl.captureStages,
                    function(stage) {
                        return !capturePoints.includes(stage.CapturePoint);
                    });

                $ctrl.captureStages = _.sortBy($ctrl.captureStages,
                    function(stage) {
                        return _.indexOf(capturePoints, stage.CapturePoint);
                    });
            }
        };
    };

})(window.app, window.angular);